import React from 'react';
import './About.css'

const AboutUs = () => {
    return (
        <div className="container">
            <div className="about-banner mb-3">
                <h1 className="text-center text-white pt-5">About Us</h1>
            </div>
            <div className="title pb-1 mb-2 mt-2">
                <h2>WELCOME TO OUR</h2>
                <h1 className="text-primary">Dental Clinic</h1>
            </div>
            <div>
                <p>Dental Clinic started its journey in 2003. It`s is the only private dental college in Chittagong division. Its large and beautiful campus has been built in 1.5 acre of it`s own land. It has now more than 300 students studying in various terms / years under Bachelor of Dental Surgery (BDS). It has been providing world Class BDS degree for students from all over the world. Eight of our batches already passed out successfully and they proved their worth as a doctor after completing degree. Most of them are now serving various national and international organizations with their excellent professional knowledge and education in dentistry. It has a state of the art Dental Hospital named Dental Clinic adjacent to it. Initially it started with 4 dental chairs. Over the period of time a number of treatment facilities added, modern equipment`s included and dental chairs have been increased to 50. Since establishment it has been contributing to the society with its specialized treatment facilities as well as providing training and research facilities for it`s students and doctors. </p>
            </div>
    

        </div>
    );
};

export default AboutUs;